import { BillingCycle, WorkspacePlan } from '@up2stay/up2promo-api-client';

import { REPUTATION_LOCATION_ADDON_MONTHLY_EUR } from '@/core/authz/entitlement-catalog';

/**
 * Must stay aligned with backend `STRIPE_TRIAL_DAYS` (Checkout
 * `subscription_data.trial_period_days`). Used for onboarding/billing copy.
 */
export const TRIAL_DAYS = 14;

/** List prices for FREE / PLUS / TEAMS (EUR, tax-exclusive). */
export const PLAN_PRICING: Record<
  WorkspacePlan.FREE | WorkspacePlan.PLUS | WorkspacePlan.TEAMS,
  { monthly: number; yearly: number }
> = {
  [WorkspacePlan.FREE]: { monthly: 0, yearly: 0 },
  [WorkspacePlan.PLUS]: { monthly: 9, yearly: 90 },
  [WorkspacePlan.TEAMS]: { monthly: 7, yearly: 70 },
};

/**
 * Yearly list price is 10× monthly (e.g. €9 → €90), i.e. two months free
 * versus paying monthly for a year. Shared by Plus and Teams.
 */
export const YEARLY_FREE_MONTHS = 2;

export const PLAN_INCLUDED_REPUTATION_LOCATIONS: Record<WorkspacePlan, number> =
  {
    [WorkspacePlan.FREE]: 0,
    [WorkspacePlan.PLUS]: 1,
    [WorkspacePlan.TEAMS]: 2,
    [WorkspacePlan.ENTERPRISE]: 10,
  };

export const TEAMS_SEAT_MINIMUM = 3;

export const REPUTATION_LOCATION_ADDON_YEARLY_EUR =
  REPUTATION_LOCATION_ADDON_MONTHLY_EUR * 10;

export function planPriceForCycle(
  plan: WorkspacePlan.FREE | WorkspacePlan.PLUS | WorkspacePlan.TEAMS,
  cycle: BillingCycle,
): number {
  return cycle === BillingCycle.YEARLY
    ? PLAN_PRICING[plan].yearly
    : PLAN_PRICING[plan].monthly;
}

export function reputationAddonPriceForCycle(cycle: BillingCycle): number {
  return cycle === BillingCycle.YEARLY
    ? REPUTATION_LOCATION_ADDON_YEARLY_EUR
    : REPUTATION_LOCATION_ADDON_MONTHLY_EUR;
}
